import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

export const IconWrap = styled.div`
  margin-right: 16px;
`;

export const IconMessageWrap = styled.div`
  display: flex;
  align-items: center;

  h5 {
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    margin: 0;
    margin-bottom: 4px;
  }

  p {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme.darkGray + theme.transparency.t50};
    margin: 0;
  }
`;

/**
 * One container for every app, with its behaviour baked in rather than passed
 * at each of the four call sites.
 *
 * `stacked` collapses a burst into a pile that expands on hover, which is what
 * makes a chat usable: five messages arriving at once used to be five banners
 * covering the page one under another, and the sixth pushed the first off
 * screen before it had been read. Needs react-toastify 10 or newer.
 */
export const StyledToastContainer = styled(ToastContainer).attrs({
  stacked: true,
  position: 'top-right' as const,
})`
  &&&.Toastify__toast-container {
    max-width: 400px;
    width: calc(100% - 40px);
    top: 20px;
    right: 20px;
    left: auto;
    transform: none;

    .Toastify__toast {
      box-shadow: ${({ theme }) => theme.shadows.shadow1};
      border-radius: 16px;
      margin-bottom: 16px;
      padding: 6px 16px 6px 10px;
      display: flex;
      align-items: center;
    }

    /* Stacked toasts are positioned by the library, which measures them and
       writes the offset into a custom property. A margin on top of that would
       be counted twice - the pile would drift apart as it grew. */
    .Toastify__toast--stacked {
      margin-bottom: 0;
    }

    .Toastify__toast-body {
      margin: none !important;
      padding: none !important;
    }

    .Toastify__progress-bar {
    }
    .Toastify__close-button {
      align-self: center;
      margin-right: 8px;
    }
    .Toastify__close-button > svg {
      height: 22px;
      width: 22px;
      /* fill: #c4c4c4; */
    }
  }
`;
